import { defineMessages } from 'react-intl'

export default defineMessages({
  title: 'The freshcells spirit',
  item1: 'We always remain ourselves.',
  item2: 'We promote individual talents.',
  item3: 'We are creative nerds from a wide variety of fields.',
  item4: 'We do not hide.',
  item5: 'We communicate openly, honestly & fairly.',
  item6: 'We build on respect, trust & responsibility.',
  item7: 'We are innovation driven and willing to invest in ideas.',
  item8: 'We know that the best results can only be achieved as a team.',
  item9: 'We make mistakes, but we learn from them.',
  item10: 'We are open, we are courageous.'
})
